import * as React from 'react';
const CustomerImagePlaceholderIcon = () => (
  <svg width={52} height={64} fill="none">
    <rect x={0.5} y={0.5} width={51} height={63} rx={3.5} fill="#FCFCFD" stroke="#E8E8E8" />
    <path
      d="M40.724 48.667H11.417c-1.15 0-2.1-.937-1.959-2.078 1.236-9.94 11.32-12.505 16.524-12.505 12.464.784 16.159 7.9 16.63 12.679.107 1.074-.809 1.904-1.888 1.904ZM34.333 23.667a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Z"
      fill="#CACED5"
    />
  </svg>
);
export default CustomerImagePlaceholderIcon;
